import { configuration } from 'mmfintech-checkout-commons'
import { isBase64EncodedImage } from 'mmfintech-commons'

import type { SupportedBank } from 'mmfintech-checkout-commons/types'

import CustomBankIcon from '@assets/icons/bank-icon.svg?react'

type BankIconProps = {
  bank: SupportedBank
}

const BankIcon = ({ bank }: BankIconProps) => {
  if (!bank) return null

  if (bank.logoUrl) {
    return (
      <img
        src={
          isBase64EncodedImage(bank.logoUrl) || bank.logoUrl.substring(0, 4) === 'http'
            ? bank.logoUrl
            : `${configuration.readBackendConfig()}${bank.logoUrl}`
        }
        alt=''
      />
    )
  }

  return <CustomBankIcon />
  // return isValidArray(bank?.options) ? <CustomBankIcon /> : <CustomBankIcon />
}

export default BankIcon
